import { request } from '../../Common/api/client';

/**
 * GET /api/cp/auth/me - 가맹점 내 정보 조회
 * 응답: { cp: { id, cp_id, name, boss_name, business_no, address, phone, ... } }
 */
export async function cpMe() {
  // Common client의 request는 code === 1000 일 때 data를 그대로 반환하므로,
  // 여기서는 data.cp 만 꺼내서 반환
  const data = await request({ method: 'GET', url: '/api/cp/me' });
  return data?.cp ?? null;
}

